const DEFAULT_LOCALE = 'zh_CN'

const modules = import.meta.glob('./main/resources/*/**/*.json', {
  eager: true,
  import: 'default',
})

const catalog = new Map()

function normalizeLocale(locale) {
  if (!locale) return DEFAULT_LOCALE
  const value = String(locale).trim()
  if (value === 'zh' || value.toLowerCase().startsWith('zh')) return 'zh_CN'
  if (value === 'en' || value.toLowerCase().startsWith('en')) return 'en_US'
  return DEFAULT_LOCALE
}

Object.entries(modules).forEach(([path, value]) => {
  const match = path.match(/\.\/main\/resources\/([^/]+)\/(.+)\.json$/)
  if (!match) return
  const [, locale, name] = match
  catalog.set(`${locale}:${name}`, value)
})

export function getLocaleCode(locale) {
  return normalizeLocale(locale)
}

export function getMessages(namespace, locale) {
  const localeCode = normalizeLocale(locale)
  return (
    catalog.get(`${localeCode}:${namespace}`) ||
    catalog.get(`${DEFAULT_LOCALE}:${namespace}`) ||
    {}
  )
}

export function formatMessage(template, params = {}) {
  return String(template || '').replace(/\{(\w+)\}/g, (_, key) => {
    const value = params[key]
    return value == null ? '' : String(value)
  })
}
